import { Injectable } from '@angular/core';
import { URLSearchParams } from '@angular/http'
import { AuthHttp } from 'angular2-jwt'

import { AlertService } from './alert.service';

import 'rxjs/add/operator/toPromise';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/finally';

@Injectable()
export class HttpService {
    constructor(
        private http: AuthHttp,
        private alert: AlertService
    ) {
    }

    public get(url: string, params?: any) {
        var urlSearchParams = new URLSearchParams();
        if (typeof (params) == 'object') {
            for (var key in params) {
                if (params.hasOwnProperty(key)) {
                    var element = params[key];
                    if (element instanceof Date) {
                        element = element.toDateString();
                    }
                    urlSearchParams.append(key, element);
                }
            }
        } else if (typeof (params) == 'string') {
            url += '?' + params;
        } else if (params instanceof URLSearchParams) {
            urlSearchParams = params;
        } else {

        }

        return this.http.get(url, { search: urlSearchParams }).toPromise()
            .then(s => s.json());
    }
    public post(url: string, body: any, options?: any) {
        return this.http.post(url, body, options)
            .toPromise()
            .then(s => s.json());
    }
    public getWithoutAuth(url: string) {
        return this.http.get(url).toPromise()
            .then(s => s.json());
    }

    public postWithoutAuth(url: string, body: any) {
        return this.http.post(url, body).toPromise()
            .then(s => s.json())
            .catch(this.handleError)
            ;
    }

    private handleError(response: Observable<any>): Observable<any> {
        return response;
        // if(error.status == 401){
        //     this.events.publish('auth:unauthorized');
        //     return Promise.reject(error);
        // }else{
        //     return Promise.reject(error);
        // }
    }
}


// WEBPACK FOOTER //
// ./src/providers/http.service.ts